module.exports = __webpack_public_path__ + "img/cs-basicEduS-2.ee63a923.jpg";